import { Navigate, Outlet } from "react-router-dom";

import { PATHS } from "../../../app/router/paths";
import { useAuth } from "../model/AuthContext";

type RequireRoleProps = {
  allowedRoles: readonly string[];
};

export const RequireRole = ({ allowedRoles }: RequireRoleProps) => {
  const { user } = useAuth();
  if (!user || !allowedRoles.some((role) => user.roles.includes(role))) {
    return <Navigate to={PATHS.AUTH.FORBIDDEN} replace />;
  }
  return <Outlet />;
};
